import React, { useEffect } from 'react';

const Header = () => {
    useEffect(() => {
        const mobileNav = document.querySelector('.mobile-nav');
        const navMenu = document.querySelector('.main-menu');

        if (mobileNav) {
            mobileNav.addEventListener('click', () => {
                navMenu.classList.toggle('active');
            });
        }

        return () => {
            if (mobileNav) {
                mobileNav.removeEventListener('click', () => {
                    navMenu.classList.toggle('active');
                });
            }
        };
    }, []);

    return (
        <header className="header">
            <div className="topbar">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-5 col-12">
                            <ul className="top-link">
                                <li><a href="/about">About</a></li>
                                <li><a href="/contact">Contact</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-6 col-md-7 col-12">
                            <ul className="top-contact">
                                <li><i className="fa fa-phone"></i> +1 (415) 650 4414</li>
                                <li>
                                    <i className="fa fa-envelope"></i>
                                    <a href="mailto:info@financialprosonline.com">info@financialprosonline.com</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="header-inner">
                <div className="container">
                    <div className="inner">
                        <div className="row">
                            <div className="col-lg-3 col-md-3 col-12">
                                <div className="logo">
                                    <a href="/">
                                        <img src="img/logo.png" alt="Logo" className="logo-img" />
                                    </a>
                                </div>

                                {/* Mobile Nav Button */}
                                <div className="mobile-nav">
                                  
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-9 col-12">
                                <div className="main-menu">
                                    <nav className="navigation">
                                        <ul className="nav menu">
                                            <li>
                                                <a href="/">Home</a>
                                               
                                            </li>
                                            <li><a href="/about">About</a></li>
                                            <li><a href="/testimonials">Testimonials</a></li>
                                            
                                            

                                            <li><a href="/services" >Find Your Best Annuity</a></li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                            <div className="col-lg-2 col-12">
                                <div className="get-quote">
                                    <a href="/contact" className="btn">
                                        Contact Us
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
